import '../../styles/Info.css'

export default function DivineMercyChaplet() {

    return (
        <div>
        <p className='info-text'>
 <p> O Terço da Misericórdia foi revelado por Jesus Cristo a Santa Faustina Kowalska, religiosa da Congregação das Irmãs de Nossa Senhora da Misericórdia. Irmã Faustina relatou em seu diário (nº 474-476) como Jesus lhe ensinou essa oração. <br />
  Jesus prometeu conceder tudo o que fosse pedido por meio do Terço da Misericórdia, e garantiu misericórdia especial na hora da morte àqueles que o rezarem, ou quando outros o rezarem junto a um agonizante.</p>
  <h3>Objetivos:</h3>
  <strong>Obter a Misericórdia de Deus
  - Confiar na Misericórdia de Cristo
  - Mostrar misericórdia ao próximo</strong>

  <h2>Promessas de Jesus sobre o Terço:</h2>
  <ul className='inicio'>
        <li>1. A alma que venerar a imagem da Misericórdia não perecerá.</li>
        <li>2. Essa imagem será sua proteção como glória de Cristo</li>
        <li>3. A imagem será um vaso para buscar graças.</li>
        <li>4. Quem viver sob os raios da Misericórdia não será atingido pela justiça de Deus.</li>
        <li>5. Na Hora da Misericórdia (15h), nada será negado à alma que pedir pelos méritos da Paixão.</li>
        <li>6. Quem divulgar a Divina Misericórdia será defendido por Cristo durante a vida e na morte.</li>
        <li>7. Na Festa da Misericórdia, quem se aproximar da Fonte da Vida receberá perdão total das culpas e penas.</li>
        <li>8. As almas mencionadas na Novena receberão força, alívio e graças, especialmente na hora da morte.</li>
        <li>9. Quem rezar o Terço será envolvido por Sua Misericórdia durante a vida e na morte.</li>
        <li>10. Jesus concederá tudo o que for pedido pelo Terço da Misericórdia.</li>
        <li>11. Pecadores empedernidos terão paz e morrerão em estado de graça ao rezá-lo.</li>
        <li>12. Quem glorificar e anunciar a Misericórdia será tratado conforme Sua infinita misericórdia.</li>
  </ul>
 
  <h3>Quando Rezar:</h3>
  <p> - Às 15h nas segundas, terças, quartas, sextas e nos fins de semana.</p>

  <h3>Como Rezar o Terço da Misericórdia:</h3>
<ul className='inicio'>
  <li><strong>1 – Sinal da Cruz:</strong> Em nome do Pai, do Filho e do Espírito Santo. Amém.</li>
        <li>1 Pai-Nosso</li>
        <li>1 Ave-Maria</li>
        <li>1 Credo</li>
</ul>  

  Nas contas do Pai-Nosso:
  "Eterno Pai, eu Vos ofereço o Corpo e Sangue, Alma e Divindade de Vosso diletíssimo Filho, Nosso Senhor Jesus Cristo, em expiação dos nossos pecados e dos do mundo inteiro."
 
<p> Nas contas das Ave-Marias (10 vezes):  "Pela Sua dolorosa Paixão, tende misericórdia de nós e do mundo inteiro."</p>
<p> No final do terço:  "Deus Santo, Deus Forte, Deus Imortal, tende piedade de nós e do mundo inteiro." (3 vezes.)</p>

</p>
</div>
    )
}